import { observable, action, makeObservable, runInAction } from 'mobx';
import {
    getTenantList,
    getSms,
    smsLogin,
    accountLogin,
    verifyFirst,
    verifySecond,
    getUserInfo,
    outLogin,
    tenantSort,
    getAESKey,
    codeVerifyLogin,
    checkToken
} from '../api/login';
import { updateCookie, clearCookie } from '../utils';
import message from '@/components/Toast';
import { loginURL } from './../httpService/API';
import { encryptAES } from '@/utils/index';
class Login {
    constructor() {
        makeObservable(this);
    }
    @observable
    mode = 'login'; //forget、codeVerify、login

    @action
    setMode = (v) => {
        this.mode = v;
    };

    @observable
    redirectUrl = ''; //forget

    @action
    setRedirectUrl = (v) => {
        this.redirectUrl = v;
    };

    @observable
    showTenantList = [];

    @action
    setShowTenantList = (v) => {
        this.showTenantList = v;
    };

    // @observable
    // tenantCount = 0;

    // @action
    // setTenantCount = (v) => {
    //     this.tenantCount = v;
    // };

    @observable
    key_word = '';

    @action
    setKeyWord = (v) => {
        this.key_word = v;
    };

    @observable activeIdentity = 'student'; //admin

    @action
    setActiveIdentity = (v) => {
        this.activeIdentity = v;
        if (v === 'admin') {
            this.showTenantList = this.key_word
                ? this.tenantList?.adminTenants?.filter((item) => {
                      return item.tenant_name.indexOf(this.key_word) > -1;
                  })
                : this.tenantList?.adminTenants || [];
        } else {
            this.showTenantList = this.key_word
                ? this.tenantList?.studentTenants?.filter((item) => {
                      return item.tenant_name.indexOf(this.key_word) > -1;
                  })
                : this.tenantList?.studentTenants || [];
        }
    };

    @observable
    tenantList = { adminTenants: [], studentTenants: [] };

    fetchList = async () => {
        const { data, code, msg } = await getTenantList();

        if (code === '00000') {
            runInAction(() => {
                this.tenantList = data;
                this.showTenantList = this.activeIdentity === 'admin' ? data.adminTenants : data.studentTenants;
            });
        } else {
            return message.error(msg);
        }
    };
    handleOutLogin = async (login_url, method = 'href') => {
        const { code, msg } = await outLogin();
        let url = `https://${window.location.host}`;
        if (code === '00000') {
            clearCookie(window.location.host);
            setTimeout(() => {
                if (method === 'href') {
                    window.location.href = login_url ? login_url : url;
                } else if (method === 'replace') {
                    window.location.replace(login_url ? login_url : url);
                }
            }, 0);
        } else {
            return message.error(msg);
        }
    };
    checkIsLogin = async () => {
        let isLogin = false;
        let res = await checkToken();
        if (res.success && res.data) {
            isLogin = true;
        }
        return isLogin;
    };
    handleIsLogin = async () => {
        let isLogin = await this.checkIsLogin();
        if (!isLogin) {
            return false;
        }
        if (this.redirectUrl) {
            window.location.href = this.redirectUrl;
            return;
        }
        const { code, data } = await getTenantList();
        const { adminTenants = [], studentTenants = [] } = data;
        const tenantList = [...studentTenants, ...adminTenants];

        //一个租户 直接跳走；多个租户 选择；无租户 进入无租户页面
        if (code === '00000') {
            /**
             *   - 1个租户只有管理员/学员身份且当前租户是正常状态，直接进入管理端/学员端。
             *   - 1个租户且同时有管理员/学员2个身份，默认进入学员端。
             */
            if (tenantList.length === 1) {
                if (data.studentTenants.length === 1 && !data.studentTenants[0].state) {
                    return (window.location.href = `https://${data.studentTenants[0]?.domain}/web`);
                } else if (data.adminTenants.length === 1 && !data.adminTenants[0].state) {
                    return (window.location.href = `https://${data.adminTenants[0]?.domain}`);
                }
            } else {
                window.location.href = '/list';
            }
        }
        return true;
    };
    loginCallback = async (loginInfo) => {
        //将登陆成功后的as/sk存下来
        updateCookie(Object.assign(loginInfo, { domain: window.location.host }));

        if (this.redirectUrl) {
            window.location.href = this.redirectUrl;
            return;
        }

        const { code, data } = await getTenantList();
        const { adminTenants = [], studentTenants = [] } = data;
        const tenantList = [...studentTenants, ...adminTenants];

        //一个租户 直接跳走；多个租户 选择；无租户 进入无租户页面
        if (code === '00000') {
            /**
             *   - 1个租户只有管理员/学员身份且当前租户是正常状态，直接进入管理端/学员端。
             *   - 1个租户且同时有管理员/学员2个身份，默认进入学员端。
             */
            if (tenantList.length === 1) {
                if (data.studentTenants.length === 1 && !data.studentTenants[0].state) {
                    updateCookie(data.studentTenants[0]);
                    return (window.location.href = `https://${data.studentTenants[0]?.domain}/web`);
                } else if (data.adminTenants.length === 1 && !data.adminTenants[0].state) {
                    updateCookie(data.adminTenants[0]);
                    return (window.location.href = `https://${data.adminTenants[0]?.domain}`);
                }
            } else {
                /**
                 *   - 多个租户时，跳转到选择组织页。
                 */
                window.location.href = '/list';
            }
        }
    };

    @observable captchaVisible = false;

    @action
    setCaptchaVisible = (v) => {
        this.captchaVisible = v;
    };

    @observable activeKey = 'code'; //password

    @action
    setActiveKey = (v) => {
        this.activeKey = v;
    };

    getSmn = async (params) => {
        const { code, msg } = await getSms(params);

        if (code === '00000') {
            if (params.types === 2) {
                message.error('请注意接听来电');
            }
            return true;
        } else if (code === 'A0123') {
            this.setCaptchaVisible(true);
        } else {
            message.error(msg);
            return false;
        }
    };

    smsLogin = async (params) => {
        const { code, msg, data } = await smsLogin(params);

        if (code === '00000') {
            await this.loginCallback(data);
        } else {
            return message.error(msg);
        }
    };

    codeVerifyLogin = async (params) => {
        params.multi_factor_verify_token = this.codeVerifyToken;
        const { code, msg, data } = await codeVerifyLogin(params);

        if (code === '00000') {
            await this.loginCallback(data);
        } else if (code === 'A0163') {
            //多因子 token 过期
            message.error(msg);
            this.setCodeVerifyToken('');
            this.setMode('login');
            return;
        } else {
            return message.error(msg);
        }
    };

    //多因子校验token
    @observable codeVerifyToken = '';
    @action
    setCodeVerifyToken = (v) => {
        this.codeVerifyToken = v;
    };

    accountLogin = async (params) => {
        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            params.password = encryptAES(params.password, aesKeyRes.data.aes_key);
            params.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { code, msg, data, stack_trace = '' } = await accountLogin(params);
        if (code === '00000') {
            await this.loginCallback(data);
        } else if (code === 'A0123') {
            this.setCaptchaVisible(true);
        } else if (code === 'A0162') {
            this.setMode('codeVerify');
            this.setCodeVerifyToken(stack_trace);
        } else {
            return message.error(msg);
        }
    };

    @observable forgetStep = 1;

    @action
    setForgetStep = (v) => {
        this.forgetStep = v;
    };

    @observable verify_token = '';

    verifyFirst = async (params) => {
        const { code, data, msg } = await verifyFirst(params);

        if (code === '00000') {
            runInAction(() => {
                this.forgetStep = 2;
                this.verify_token = data.verify_token;
            });
        } else {
            return message.error(msg);
        }
    };

    verifySecond = async (params) => {
        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            params.pwd = encryptAES(params.pwd, aesKeyRes.data.aes_key);
            params.confirm_pwd = encryptAES(params.confirm_pwd, aesKeyRes.data.aes_key);
            params.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { code, msg } = await verifySecond(params);

        if (code === '00000') {
            runInAction(() => {
                this.mode = 'login';
            });
        } else {
            return message.error(msg);
        }
    };

    @observable userInfo = {};

    getUserInfo = async (params) => {
        const { code, data, msg } = await getUserInfo(params);

        if (code === '00000') {
            runInAction(() => {
                this.userInfo = data;
            });
        } else {
            return message.error(msg);
        }
    };

    outLogin = async (params) => {
        const { code, msg } = await outLogin(params);

        if (code === '00000') {
            clearCookie(window.location.host);
            setTimeout(() => {
                window.location.href = loginURL;
            }, 0);
        } else {
            return message.error(msg);
        }
    };

    tenantSort = async (params) => {
        const { code, msg } = await tenantSort(params);

        if (code === '00000') {
            this.fetchList();
        } else {
            return message.error(msg);
        }
    };
}
export default new Login();
